// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoryItem_title__RR9xo","description":"CategoryItem_description__pl6rf"};